import { render, staticRenderFns } from "./OtherbillapList.vue?vue&type=template&id=6af0efc6"
import script from "./OtherbillapList.vue?vue&type=script&lang=js"
export * from "./OtherbillapList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports